module.exports = __webpack_public_path__ + "img/9.9f9f8c1c.jpg";